import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import processParams from "utils/processParams";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import BeneficiariesInlineRouter from "components/__new/beneficiaries/BeneficiariesInlineRouter";
import TransferBeneficiariesTable from "components/__new/beneficiaries/transfer/TransferBeneficiariesTable";
import SingleBeneficiaryType from "components/__new/beneficiaries/transfer/SingleBeneficiaryType";
import { createTransferBeneficiary } from "store/entities/transfers/action";
import ModalAlert from "components/__new/common/ModalAlert";
import * as transfersAction from "store/entities/transfers/action"

export const TransferBeneficiaries = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const {urlQueryParams} = useUrlQueryParams();
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const { earnipayBeneficiaryCreationData, transferBeneficiariesLoading, transferBeneficiaries } = useSelector((state) => state.entities.transfers)

    const beneficiaryTypes = [
        {
            title: "Earnipay",
            value: "earnipay",
        },
        {
            title: "Other Banks",
            value: "bank",
        },
    ]
    
    const [listParams, setListParams] = useState({
        "page": 1,
        "limit": 20,
    });
    
    const [beneficiaryType, setBeneficiaryType] = useState("earnipay");
    const [isBeneficiaryTypeOpen, setIsBeneficiaryTypeOpen] = useState(false);

    const toggleBeneficiaryType = () => setIsBeneficiaryTypeOpen(!isBeneficiaryTypeOpen)
    

    const initiateBeneficiaryCreation = (payload) => {
        dispatch(createTransferBeneficiary(payload))
    }
    
    const getTransferBeneficiaries = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 20, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "keyword");
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");

        setListParams(params);
        dispatch(transfersAction.getTransferBeneficiaries());
    }

    useEffect(() => {
        getTransferBeneficiaries();
        // eslint-disable-next-line
    }, [location]);


    useEffect(() => {
        if (earnipayBeneficiaryCreationData?.status === 'success'){
            setIsBeneficiaryTypeOpen(false);
            setIsSuccessModalOpen(true);
            // call endpoint to get inter & intra beneficiaries
        }
        // eslint-disable-next-line
    }, [earnipayBeneficiaryCreationData])

    return (
        <div>
            
            <ModalAlert
                dismissText="Close"
                isOpenModalAlert={isSuccessModalOpen}
                setIsOpenModalAlert={setIsSuccessModalOpen}
                successText="Congratulations! Your beneficiaries have been saved successfully"
            />
            
            <SingleBeneficiaryType
                isOpen={isBeneficiaryTypeOpen}
                beneficiaryType={beneficiaryType}
                beneficiaryTypes={beneficiaryTypes}
                setIsOpen={setIsBeneficiaryTypeOpen}
                setBeneficiaryType={setBeneficiaryType}
                toggleBeneficiaryType={toggleBeneficiaryType}
                initiateBeneficiaryCreation={initiateBeneficiaryCreation}
            />
            
            <BeneficiariesInlineRouter />
            
            <TransferBeneficiariesTable 
                data={transferBeneficiaries}
                loading={transferBeneficiariesLoading}
                addSingleBeneficiary={toggleBeneficiaryType}
                getTransferBeneficiaries={getTransferBeneficiaries}
            />

        </div>
    )
}


export default TransferBeneficiaries;